import { GridColDef } from '@mui/x-data-grid';
import {
  Box,
  TextField,

  Alert,
  InputAdornment,
  Typography,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { atom, useSetAtom } from 'jotai';
import SearchIcon from '@mui/icons-material/Search';
import { useMemo, useState, useEffect } from 'react';
import EditStoreOwnerModal from '../EditStoreOwnerModal';
import {
  useGetCustomersDetailsForOffers,
} from '../../Query/OffersQuery';
import { usePermissions } from '../../../context/PermissionContext';
import React from 'react';
import { useManageCmsParams } from '../ManageCMS/useManageCmsParams';
import CommonDataGrid from '../../Stateless/CommonDataGrid';
import { useDebounce } from '../Utils/useDounce';
import EditOffers from './EditOffers';
import { COLORS } from '../../../theme';
import ReplyIcon from '@mui/icons-material/Reply';
import AddWalletAmount from '../ManageWallet/AddWalletAmount';
import AssignOffersModalContent from './AssignOffersModalContent';

export interface ChoiceDataType {
  storeType: any;
  id?: any;
  choiceId?: string;
  choiceNameEnglish?: string;
  choiceNameArabic?: string;
  price: number;
  merchantId?: string;
  merchantName?: string;
  // storeType?: string;
  storeId?: string;
}

export const choiceAtom = atom<ChoiceDataType | null>(null);

// type StoreWithSno = {
//   id: string;
//   sno: number;
//   name: string;
//   storeType: string;
//   choice: string;
//   price: number;
//   status: string;
// };


const AssignOffers = () => {
  const { hasPermission } = usePermissions();
  const setChoiceAtom = useSetAtom(choiceAtom);
  // const [ setSelectedRows] = useState<string[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const snackbarMessage = ''; // Replace with actual message
  const snackbarSeverity: 'success' | 'error' | 'info' | 'warning' = 'info';
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [modalContent] = useState<'add' | 'edit'>('edit');

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebounce(searchTerm, 400);
  const { params, dispatch } = useManageCmsParams();
  const isReady = Boolean(params && Object.keys(params).length > 0);
  const memoizedParams = useMemo(() => {
    return isReady ? params : {};
  }, [isReady, params]);
  const { data: customersData, isLoading } = useGetCustomersDetailsForOffers(memoizedParams);

  //   const { mutate: patchChoice } = usePatchChoice();

  //   const { mutate: deleteChoice } = useDeleteChoice();


  //   const filteredRows = React.useMemo(() => {
  //     const storeOwners = choiceData?.data || [];

  //     // Add sno field to each row and ensure all required fields are present
  //     return storeOwners.map((row, index) => {
  //       // Ensure we have a valid row object
  //       if (!row) return { id: `empty-${index}`, sno: index + 1 } as StoreWithSno;

  //       // Create a new object with all the row properties plus sno
  //       const rowWithSno = {
  //         ...row,
  //         id: row.choiceId,
  //         sno: index + 1 + (Number(params.page - 1)) * Number(params.limit),
  //         name: row.storeName,
  //         storeType: row.storeType,
  //         choice: row.choiceNameEnglish,
  //         price: row.price,
  //         status: row.status,
  //       };

  //       return rowWithSno as StoreWithSno;
  //     });
  //   }, [params.search, choiceData, params.page, params.limit]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
  };

  useEffect(() => {
    // Trim the search term to remove leading/trailing spaces
    // Convert empty string to undefined so backend doesn't receive empty search
    const trimmedSearch = debouncedSearch?.trim();
    dispatch({ type: 'SET_SEARCH', payload: trimmedSearch || undefined });
  }, [debouncedSearch, dispatch]);

  // const handlePageChange = (newPage: number) => {
  //   dispatch({ type: 'SET_PAGE', payload: newPage + 1 });
  // };

  // const handlePageSizeChange = (newSize: number) => {
  //   dispatch({ type: 'SET_LIMIT', payload: newSize });
  // };

  //   const handleBlockClick = async () => {
  //     console.log('selectedRows', selectedRows);
  //     if (selectedRows.length === 0) {
  //       showMessage('Please select at least one choice to block', 'error');
  //     } else {
  //       const confirmed = window.confirm('Are you sure you want to block?');
  //       if (!confirmed) return;

  //       patchChoice({
  //         id: selectedRows,
  //         data: { status: 'blocked' },
  //       });
  //     }
  //   };

  //   const handleUnBlockClick = async () => {
  //     if (selectedRows.length === 0) {
  //       showMessage('Please select at least one choice to unblock', 'error');
  //     } else {
  //       const confirmed = window.confirm('Are you sure you want to unblock?');
  //       if (!confirmed) return;

  //       patchChoice({
  //         id: selectedRows,
  //         data: { status: 'unblocked' },
  //       });
  //     }
  //   };

  //   const handleDeleteClick = useCallback(() => {
  //     console.log('delete', selectedRows);
  //     if (selectedRows.length === 0) {
  //       showMessage('Please select at least one choice to delete', 'error');
  //       return;
  //     }

  //     const confirmed = window.confirm('Are you sure you want to delete?');
  //     if (!confirmed) return;

  //     // Clear selected rows immediately after confirmation
  //     setSelectedRows([]);

  //     deleteChoice(selectedRows, {
  //       onSuccess: () => {
  //         console.log("updated code")
  //         showMessage('choice deleted successfully', 'success');
  //         // Refetch data to update the table
  //         refetch();
  //       },
  //       onError: () => {
  //         showMessage('Error deleting choice', 'error');
  //         // If there's an error, we might want to restore the selection
  //         // setSelectedRows(selectedRows); // Uncomment if you want to restore selection on error
  //       },
  //     });
  //   }, [selectedRows, showMessage, deleteChoice, refetch]);

  //   const handleBlockClickButton = async (id: string) => {
  //     const confirmed = window.confirm(
  //       'Are you sure you want to block this Choice?'
  //     );
  //     if (!confirmed) return;

  //     await patchChoice({
  //       id: [id],
  //       data: { status: 'blocked' },
  //     });
  //   };
  //   const handleUnBlockClickButton = async (id: string) => {
  //     const confirmed = window.confirm(
  //       'Are you sure you want to unblock this Choice?'
  //     );
  //     if (!confirmed) return;

  //     await patchChoice({
  //       id: [id],
  //       data: { status: 'unblocked' },
  //     });
  //   };

  //   const handleDeleteButton = useCallback(
  //     (id: string) => {
  //       const confirmed = window.confirm('Are you sure you want to delete?');
  //       if (!confirmed) return;

  //       deleteChoice([id], {
  //         onSuccess: () => {
  //           showMessage('choice deleted successfully', 'success');
  //           refetch();
  //         },
  //         onError: () => {
  //           showMessage('Error deleting choice', 'error');
  //         },
  //       });
  //     },
  //     [deleteChoice, showMessage, refetch]
  //   );

  const handleAddSubAdmin = () => {
    setOpenAddDialog(true);
  };

  // Add this handler for Add Offers from modal
  const handleAddOfferFromModal = () => {
    setOpenAssignOffersModal(false);
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  //   const handleEditClick = (row: any) => {
  //     setChoiceAtom(row);
  //     setOpenEditDialog(true);
  //   };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setChoiceAtom(null);
  };

  // const handleCategorySelection = (selectionModel: GridRowId[]) => {
  //   setSelectedRows(selectionModel as string[]);
  // };

  const [openWalletModal, setOpenWalletModal] = useState(false);
  //   const [walletForm, setWalletForm] = useState({
  //     description: '',
  //     descriptionAr: '',
  //     amount: '',
  //   });

  const [openAssignOffersModal, setOpenAssignOffersModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const columns: GridColDef[] = [
    {
      field: 'sno',
      headerName: 'S.No',
      flex: 0.3,
    },
    {
      field: 'userName',
      headerName: 'Customer Name',
      flex: 2,
    },
    {
      field: 'userEmail',
      headerName: 'Customer Email',
      flex: 2,
    },
    {
      field: 'totalOrders',
      headerName: 'Total no of Orders',
      flex: 1.5,
      valueGetter: (_value, row) => {
        return row.totalOrders || 0;
      },
    },
    {
      field: 'totalOrderAmount',
      headerName: 'Total Order Amount',
      flex: 1.5,
      align: 'right',
      headerAlign: 'right',
      valueGetter: (_value, row) => {
        return row.totalOrderAmount ? `${row.totalOrderAmount.toFixed(2)} JOD` : '0.00 JOD';
      },
    },
    {
      field: 'assignOffers',
      headerName: 'Assign Offers',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        if (!hasPermission('promotionalAndOffers', 'Add') && !hasPermission('promotionalAndOffers', 'Edit')) {
          return null;
        }
        return (
          <ReplyIcon
            sx={{ cursor: 'pointer', color: '#222', transform: 'scaleX(-1)' }}
            onClick={() => {
              setSelectedCustomer(params.row);
              setOpenAssignOffersModal(true);
            }}
          />
        );
      },
      sortable: false,
      filterable: false,
    },
    {
      field: 'totalWalletAmount',
      headerName: 'Total Wallet Amount',
      flex: 1.5,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, width: '100%' }}>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>
            {params.row.totalWalletAmount ? `${params.row.totalWalletAmount.toFixed(2)} JOD` : '0.00 JOD'}
          </Typography>
          {hasPermission('wallet', 'Credit') && (
            <AddIcon
              sx={{ 
                cursor: 'pointer', 
                color: COLORS.secondary.main,
                fontSize: 20,
                '&:hover': {
                  color: COLORS.secondary.dark,
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={() => {
                setSelectedCustomer(params.row);
                setOpenWalletModal(true);
              }}
            />
          )}
        </Box>
      ),
      sortable: false,
      filterable: false,
    },
    {
      field: 'loyaltyPoints',
      headerName: 'Loyalty Points',
      flex: 1,
      valueGetter: (_value, row) => {
        return row.loyaltyPoints || 0;
      },
    },
  ];

  // Transform customers data for DataGrid
  const rows = useMemo(() => {
    const customers = customersData?.data || [];
    return customers.map((customer: any, index: number) => ({
      id: customer.id || customer.userId,
      sno: index + 1 + (Number(params.page - 1)) * Number(params.limit),
      userName: customer.userName || customer.customerName || '-',
      userEmail: customer.userEmail || customer.customerEmail || '-',
      totalOrders: customer.totalOrders || customer.noOfOrders || 0,
      totalOrderAmount: customer.totalOrderAmount || 0,
      walletUsed: customer.walletUsed || customer.totalDebited || 0,
      loyaltyPoints: customer.loyaltyPoints || 0,
      totalWalletAmount: customer.walletBalance || customer.totalWalletAmount || customer.totalCredited || customer.availableWalletBalance || 0,
      userId: customer.id || customer.userId,
      ...customer,
    }));
  }, [customersData, params.page, params.limit]);

  const handleRowSelection = () => {
    // Handle row selection if needed
  };

  const handlePageChange = (newPage: number) => {
    dispatch({ type: 'SET_PAGE', payload: newPage + 1 });
  };

  const handlePageSizeChange = (newSize: number) => {
    dispatch({ type: 'SET_LIMIT', payload: newSize });
  };



  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Assign Offers and Loyalty Rewards
      </Typography>
      <Box
        sx={{
          p: 2,
          border: '1px solid #e0e0e0',
          marginTop: '20px',
          color: '#666',
        }}
      >
        {snackbarOpen && (
          <Box sx={{ mb: 2 }}>
            <Alert
              severity={snackbarSeverity}
              onClose={() => setSnackbarOpen(false)}
            >
              {snackbarMessage}
            </Alert>
          </Box>
        )}

        <Box
          sx={{
            // p: 2,
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2, // Optional: adds spacing between wrapped items
          }}
        >
          {/* Search - Left */}
          <Box
            sx={{
              width: 600,
              border: '1px solid #ccc',
              borderRadius: '8px',
              background: '#fff',
            }}
          >
            <TextField
              fullWidth
              placeholder="Search by name, email"
              size="medium"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{
                '.MuiOutlinedInput-root': {
                  height: 40,
                  width: 600,
                  border: 'none', // remove inner border
                },
                '& fieldset': {
                  border: 'none', // remove Material-UI default border
                },
                '& .MuiInputBase-input': {
                  paddingTop: '10px', // adjust this value to move the placeholder lower
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ fontSize: 20, color: '#aaa', mt: '4px' }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {/* Action Buttons + Add Button - Right */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
            }}
          >

            {hasPermission('promotionalAndOffers', 'Add') && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAddSubAdmin}
                size="small"
                sx={{
                  textTransform: 'none',
                  borderRadius: 2,
                  bgcolor: COLORS.primary.main,
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: COLORS.primary.main,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  },
                }}
              >
                Add Offer
              </Button>
            )}
          </Box>
        </Box>

        <EditStoreOwnerModal
          open={openAddDialog}
          onClose={handleCloseAddDialog}
          title="Add Offer"
        >
          <EditOffers onCancel={handleCloseAddDialog} />
        </EditStoreOwnerModal>

        <EditStoreOwnerModal
          open={openEditDialog}
          onClose={handleCloseEditDialog}
          title={modalContent === 'add' ? 'Add Offer' : 'Edit Offer'}
        >
          <EditOffers onCancel={handleCloseEditDialog} />
        </EditStoreOwnerModal>

        {/* Wallet Modal */}
        <EditStoreOwnerModal
          open={openWalletModal}
          onClose={() => {
            setOpenWalletModal(false);
            setSelectedCustomer(null);
          }}
          title="Add wallet amount"
        >
          <AddWalletAmount 
            onCancel={() => {
              setOpenWalletModal(false);
              setSelectedCustomer(null);
            }} 
            mode={'add'} 
            customer={selectedCustomer}
          />
        </EditStoreOwnerModal>

        <EditStoreOwnerModal
          open={openAssignOffersModal}
          onClose={() => setOpenAssignOffersModal(false)}
          title="Assign Offers and Loyalty Rewards"
        >
          <AssignOffersModalContent
            customer={selectedCustomer}
            onClose={() => setOpenAssignOffersModal(false)}
            onAddOffer={handleAddOfferFromModal}
          />
        </EditStoreOwnerModal>

        {/* <CommonDataGrid
          key={`datagrid-page-${params.page}-limit-${params.limit}`}
          rows={rows || []}
          columns={columns}
          pageSize={params.limit}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          checkboxSelection
          loading={isLoading}
          page={params.page - 1}
          rowCount={choiceData?.pagination?.totalItems}
          components={{
            NoRowsOverlay: () => <ErrorHandler type="no-data" message="No categories found" onRetry={() => refetch()} />
          }}
          onRowSelectionModelChange={handleCategorySelection}
          selectionModel={selectedRows}
        /> */}
        <CommonDataGrid
          key={`datagrid-page-${params.page}-limit-${params.limit}`}
          rows={rows || []}
          columns={columns}
          pageSize={params.limit}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={isLoading}
          page={params.page - 1}
          rowCount={customersData?.pagination?.totalItems}
          components={{}}
          checkboxSelection
          onRowSelectionModelChange={handleRowSelection}
        />
      </Box>
    </>
  );
};

export default AssignOffers;
